<div class="acp">
  <div class="acp-head">
    <div>
      <h3 class="acp-h3">El Avance de Contabilidad, de enero a hoy</h3>
      <p class="acp-sub">
        Cada mes se mide como en su hoja: lo que venció ese mes, lo cobrado de ello a la fecha y lo que falta. La plataforma gana cuando
        mide; lo capturado del libro solo se usa donde no hay letras.
      </p>
    </div>
  </div>

  <div class="acp-skeleton" *ngIf="cargando"><p-skeleton height="10rem"></p-skeleton></div>

  <div class="acp-error" *ngIf="!cargando && error" role="alert">
    <i class="fa-solid fa-circle-exclamation"></i>
    <span>{{ error }}</span>
    <button pButton type="button" class="p-button-sm p-button-text" label="Reintentar" (click)="cargar()"></button>
  </div>

  <div class="acp-empty" *ngIf="!cargando && !error && !meses.length">No hay meses que enseñar para este año.</div>

  <div class="acp-scroll" *ngIf="!cargando && !error && meses.length">
    <table class="acp-table">
      <thead>
        <tr>
          <th>Mes</th>
          <th class="num">Total cartera</th>
          <th class="num">Cobrado</th>
          <th class="num">Por cobrar</th>
          <th class="num">% avance</th>
          <th>De dónde sale</th>
          <th class="num">Captura del libro</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let m of meses">
          <td>{{ nombreMes(m.month) }}</td>
          <!-- Un mes sin datos dice «—», no $0.00: cero sería afirmar que se midió y no entró nada. -->
          <ng-container *ngIf="m.source !== 'SIN_DATOS'; else sinDatos">
            <td class="num">{{ m.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td class="num">{{ m.collected | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td class="num">{{ m.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td class="num">{{ pct(m.rate) }}</td>
          </ng-container>
          <ng-template #sinDatos>
            <td class="num acp-muted">—</td>
            <td class="num acp-muted">—</td>
            <td class="num acp-muted">—</td>
            <td class="num acp-muted">—</td>
          </ng-template>
          <td><p-tag [value]="fuente(m).label" [severity]="fuente(m).sev" [pTooltip]="fuente(m).tip" tooltipPosition="top"></p-tag></td>
          <td class="num">
            <ng-container *ngIf="m.captured?.total != null; else sinCaptura">
              {{ m.captured?.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}
              <span class="acp-diff" *ngIf="diferencia(m) as d" [class.is-off]="d !== 0">
                {{ d > 0 ? '+' : '' }}{{ d | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }} vs plataforma
              </span>
            </ng-container>
            <ng-template #sinCaptura><span class="acp-muted">—</span></ng-template>
          </td>
          <td class="acp-actions">
            <button
              *appIfHasPermission="['wallet', 'settings']"
              pButton
              type="button"
              class="p-button-sm p-button-text"
              [icon]="capturaDe(m.month) ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"
              [label]="capturaDe(m.month) ? 'Corregir' : 'Capturar'"
              [attr.aria-label]="(capturaDe(m.month) ? 'Corregir la captura de ' : 'Capturar ') + nombreMes(m.month)"
              (click)="abrirCaptura(m)"
            ></button>
            <button
              *ngIf="capturaDe(m.month) as c"
              pButton
              type="button"
              class="p-button-sm p-button-text p-button-secondary"
              icon="fa-solid fa-clock-rotate-left"
              pTooltip="Historial de la captura"
              [attr.aria-label]="'Historial de ' + nombreMes(m.month)"
              (click)="verHistorial(c)"
            ></button>
            <ng-container *ngIf="capturaDe(m.month) as c">
              <button
                *appIfHasPermission="['wallet', 'settings']"
                pButton
                type="button"
                class="p-button-sm p-button-text p-button-danger"
                icon="fa-solid fa-trash-can"
                pTooltip="Dar de baja la captura"
                [attr.aria-label]="'Dar de baja la captura de ' + nombreMes(m.month)"
                (click)="abrirBaja(c)"
              ></button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- ── Capturar / corregir ──────────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarCaptura"
  [modal]="true"
  [closable]="!guardando"
  [header]="(corrigiendo ? 'Corregir ' : 'Capturar ') + (capMes ? nombreMes(capMes) : '')"
  styleClass="acp-dialog"
  [style]="{ width: '520px', maxWidth: '96vw' }"
>
  <p class="acp-note">
    Son los totales del mes tal como vienen en la hoja AVANCE de Contabilidad. <b>No modifica ningún arrendamiento.</b>
    <span *ngIf="corrigiendo"> El cambio queda en el historial con tu nombre y el motivo.</span>
  </p>
  <div class="acp-form">
    <label for="acp-total">Total cartera *</label>
    <p-inputNumber
      inputId="acp-total"
      [(ngModel)]="capTotal"
      mode="currency"
      currency="MXN"
      locale="es-MX"
      [min]="0"
      (onBlur)="completar()"
    ></p-inputNumber>
    <label for="acp-cobrado">Cobrado</label>
    <p-inputNumber
      inputId="acp-cobrado"
      [(ngModel)]="capCobrado"
      mode="currency"
      currency="MXN"
      locale="es-MX"
      [min]="0"
      (onBlur)="completar()"
    ></p-inputNumber>
    <label for="acp-pendiente">Por cobrar</label>
    <p-inputNumber
      inputId="acp-pendiente"
      [(ngModel)]="capPendiente"
      mode="currency"
      currency="MXN"
      locale="es-MX"
      [min]="0"
      (onBlur)="completar()"
    ></p-inputNumber>
    <label for="acp-motivo">Motivo {{ corrigiendo ? '*' : '(opcional)' }}</label>
    <textarea
      id="acp-motivo"
      pInputTextarea
      [(ngModel)]="capMotivo"
      rows="2"
      maxlength="500"
      placeholder="Por qué se captura o corrige"
    ></textarea>
  </div>
  <p class="acp-hint" *ngIf="!capError && problemaCaptura && capTotal != null">{{ problemaCaptura }}</p>
  <div class="acp-error" *ngIf="capError" role="alert">
    <i class="fa-solid fa-circle-exclamation"></i><span>{{ capError }}</span>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" [disabled]="guardando" (click)="mostrarCaptura = false"></button>
    <button
      pButton
      type="button"
      [label]="corrigiendo ? 'Guardar corrección' : 'Guardar captura'"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="!!problemaCaptura"
      (click)="guardar()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ── Historial ────────────────────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarHistorial"
  [modal]="true"
  [header]="'Historial · ' + (historialDe ? nombreMes(historialDe.month) : '')"
  styleClass="acp-dialog"
  [style]="{ width: '680px', maxWidth: '96vw' }"
>
  <p class="acp-note" *ngIf="historialDe">Fuente: {{ historialDe.source }}</p>
  <div class="acp-empty" *ngIf="!historialDe?.history?.length">Sin cambios registrados.</div>
  <table class="acp-table" *ngIf="historialDe?.history?.length">
    <thead>
      <tr>
        <th>Fecha</th>
        <th>Campo</th>
        <th class="num">Antes</th>
        <th class="num">Después</th>
        <th>Motivo</th>
        <th>Quién</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let h of historialDe?.history">
        <td>{{ h.date | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ campo(h.field) }}</td>
        <td class="num">{{ h.previousValue == null ? '—' : (h.previousValue | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
        <td class="num">{{ h.newValue == null ? '—' : (h.newValue | currency: 'MXN' : 'symbol-narrow' : '1.2-2') }}</td>
        <td>{{ h.reason || '—' }}</td>
        <td>{{ autor(h) }}</td>
      </tr>
    </tbody>
  </table>
</p-dialog>

<!-- ── Baja ─────────────────────────────────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarBaja"
  [modal]="true"
  [closable]="!dandoDeBaja"
  [header]="'Dar de baja la captura de ' + (bajaDe ? nombreMes(bajaDe.month) : '')"
  styleClass="acp-dialog"
  [style]="{ width: '480px', maxWidth: '96vw' }"
>
  <p class="acp-note">
    La captura no se borra: se marca como dada de baja y el mes vuelve a salir con lo que mida la plataforma o «sin datos».
  </p>
  <div class="acp-form">
    <label for="acp-baja">Motivo *</label>
    <textarea id="acp-baja" pInputTextarea [(ngModel)]="bajaMotivo" rows="2" maxlength="500"></textarea>
  </div>
  <div class="acp-error" *ngIf="bajaError" role="alert">
    <i class="fa-solid fa-circle-exclamation"></i><span>{{ bajaError }}</span>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" [disabled]="dandoDeBaja" (click)="mostrarBaja = false"></button>
    <button
      pButton
      type="button"
      class="p-button-danger"
      label="Dar de baja"
      icon="fa-solid fa-trash-can"
      [loading]="dandoDeBaja"
      [disabled]="!bajaMotivo.trim()"
      (click)="darDeBaja()"
    ></button>
  </ng-template>
</p-dialog>
